export const VISITOR_COOKIE = "hl_vid"
export const SESSION_COOKIE = "hl_sid"
export const STAFF_ANALYTICS_MARKER = "hl_staff_analytics_opt_out"

export const VISITOR_COOKIE_MAX_AGE = 60 * 60 * 24 * 365
export const SESSION_COOKIE_MAX_AGE = 60 * 30

const TRACKING_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export const ANALYTICS_EXCLUDED_PREFIXES = [
  "/admin",
  "/api",
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
  "/blocked",
  "/ingest",
]

export function isAnalyticsPathExcluded(pathname: string) {
  return ANALYTICS_EXCLUDED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  )
}

export function hasAnalyticsPrivacyOptOut(headers: Headers) {
  return (
    headers.get("dnt") === "1" ||
    headers.get("sec-gpc") === "1"
  )
}

export function getValidTrackingId(value: string | null | undefined) {
  return value && TRACKING_ID_PATTERN.test(value)
    ? value.toLowerCase()
    : null
}

// If storage is unavailable, avoid tracking until privacy preferences are readable.
export function isBrowserAnalyticsBlocked() {
  try {
    return localStorage.getItem(STAFF_ANALYTICS_MARKER) === "1"
  } catch {
    return true
  }
}
